export default __webpack_public_path__ + "static/media/comment-base.1c964ed4.svg";